<template>
  <ul v-if="totalItems > itemsPerPage" class="pagination">
    <li class="page-prev">
      <a class="btn btn-link text-default-color" :class="{'btn-disable-hover': currentPage === 1}" @click.prevent="currentPage = prevPage">
        <i class="fa fa-angle-left"></i>
      </a>
    </li>
    <li v-for="page in pages">
      <span class="btn btn-link text-default-color" v-if="currentPage !== page && !isNaN(page)">
        <a href="#" class="page-numbers" @click.prevent="currentPage = page">{{ page }}</a>
      </span>
      <span class="btn btn-link text-default-color" v-if="currentPage === page && !isNaN(page)">
        <span href="#" class="page-numbers current">{{ page }}</span>
      </span>
      <span class="btn btn-link text-default-color" v-if="page === '...'">
        <span class="page-numbers dots">…</span>
      </span>
    </li>
    <li class="page-next">
      <a class="btn btn-link text-default-color" :class="{'btn-disable-hover': currentPage === totalPages}" @click.prevent="currentPage = nextPage">
        <i class="fa fa-angle-right"></i>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  emits: ["update:modelValue"],
  props: {
    totalItems: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      required: true
    },
    modelValue: {
      type: Number,
    },
  },
  data() {
    return {
      currentPage: 1,
      nextPage: 0,
      prevPage: 0,
      pages: [],
    }
  },
  computed: {
    totalPages() {
      return Math.floor(this.totalItems / this.itemsPerPage)
    }
  },
  methods: {
    updateNextPrev() {
      this.nextPage = (this.currentPage < this.totalPages) ? this.currentPage + 1 : this.totalPages;
      this.prevPage = (this.currentPage > 1) ? this.currentPage - 1 : 1;
    },
    updatePages() {
      this.pages = [];
      let prevPages = 1;
      let nextPages = 1;
      const pageOffset = 4;
      const pageCounterOffset = pageOffset - 1;

      if (this.currentPage > pageOffset) {
        prevPages = (this.currentPage - pageCounterOffset) + 1;
        this.pages.push(1);
        this.pages.push('...');
      }

      if (this.currentPage <= this.totalPages) {
        nextPages = this.currentPage + pageCounterOffset;
      }

      if (nextPages > this.totalPages) {
        nextPages = this.totalPages;
      }

      for (let page = prevPages; page < nextPages; page++) {
        this.pages.push(page);
      }

      if (this.currentPage < this.totalPages - pageCounterOffset) {
        this.pages.push('...');
      }

      this.pages.push(this.totalPages);
    },
    updatePager() {
      this.updateNextPrev();
      this.updatePages();
    }
  },
  watch: {
    modelValue: {
      handler(newValue) {
        if (newValue) {
          this.currentPage = newValue;
          this.updatePager();
        }
      },
      immediate: true
    },
    currentPage(newValue) {
      this.$emit("update:modelValue", newValue);
      this.updatePager();
    },
    totalItems() {
      this.currentPage = 1;
      this.updatePager();
    }
  }
}
</script>

<style scoped>

</style>
